const claimPoints = {
    elements: {
        selectedValue: '#select-member option:selected',
        dateOfVisit: '#date-of-visit',
        dateError: '#date-error',
        dentalSurgeryName: '#dental-surgery-name',
        dentalSurgeryError: '#surgery-name-error',
        dentalPostCodeName: '#dental-surgery-postcode',
        postCodeError: '#postcode-error',
        invalidPostCodeError: '#invalid-postcode-error',
        confirmMemberVisit: '#confirm-no-other-member-visit',
        confirmationError: '#confirmation-error',
        submit: '#submit-points',
        notification: '.vds-notification',
        thanksModal: '.vds-notification--success'
    },
    urls: {
        error: '/error/error-page'
    },
    func: {
        init: function () {
            claimPoints.func.loadValues();
            claimPoints.func.bindings();
        },
        bindings: function () {
            $(claimPoints.elements.dentalSurgeryName).on('input', claimPoints.func.checksurgeryNameField);
            $(claimPoints.elements.dentalPostCodeName).on('input', claimPoints.func.checkPostCode);
            $(claimPoints.elements.confirmMemberVisit).on('input', claimPoints.func.checkConfirmation);
            $(claimPoints.elements.dateOfVisit).on('change', claimPoints.func.checkDateOfVisit);
            $(claimPoints.elements.submit).on('click', claimPoints.func.submitQuery);
        },
        loadValues: function () {
            $(claimPoints.elements.datePastError).hide();
            $(claimPoints.elements.dentalSurgeryError).hide();
            $(claimPoints.elements.postCodeError).hide();
            $(claimPoints.elements.invalidPostCodeError).hide();
            $(claimPoints.elements.confirmationError).hide();
            $(claimPoints.elements.dateError).hide();
            $(claimPoints.elements.notification).hide();
        },
        checksurgeryNameField: function () {
            if ($(claimPoints.elements.dentalSurgeryName).val().trim() === '') {
                $(claimPoints.elements.dentalSurgeryError).show();
                return false;
            } else {
                $(claimPoints.elements.dentalSurgeryError).hide();
                return true;
            }
        },
        checkPostCode: function () {
            const postCodeRegex =
                /^(GIR ?0AA|[A-PR-UWYZa-pr-uwyz]([0-9]{1,2}|([A-HK-Ya-hk-y][0-9]([0-9ABEHMNPRV-Yabehmnprv-y])?)|[0-9][A-HJKPS-UWa-hjkps-uw]) ?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/;
            const postcodes = $(claimPoints.elements.dentalPostCodeName).val().match(postCodeRegex);
            if ($(claimPoints.elements.dentalPostCodeName).val() === '') {
                $(claimPoints.elements.postCodeError).show();
                $(claimPoints.elements.invalidPostCodeError).hide();
                return false;
            } else if (postcodes === null) {
                $(claimPoints.elements.postCodeError).hide();
                $(claimPoints.elements.invalidPostCodeError).show();
                return false;
            } else {
                $(claimPoints.elements.postCodeError).hide();
                $(claimPoints.elements.invalidPostCodeError).hide();
                return true;
            }
        },
        checkConfirmation: function () {
            if (!$(claimPoints.elements.confirmMemberVisit).prop('checked')) {
                $(claimPoints.elements.confirmationError).show();
                return false;
            } else {
                $(claimPoints.elements.confirmationError).hide();
                return true;
            }
        },
        checkDateOfVisit: function () {
            const dateOfVisit = new Date($(claimPoints.elements.dateOfVisit).val());
            const todayDate = new Date();
            const lastSixMonth = new Date(new Date().setMonth(todayDate.getMonth() - 6));
            if (dateOfVisit > todayDate || dateOfVisit < lastSixMonth) {
                $(claimPoints.elements.dateError).show();
                return false;
            } else {
                $(claimPoints.elements.dateError).hide();
                return true;
            }
        },
        isValid: function () {
            let isValid = true;
            if (!claimPoints.func.checkDateOfVisit()) {
                isValid = false;
            }
            if (!claimPoints.func.checkPostCode()) {
                isValid = false;
            }
            if (!claimPoints.func.checkConfirmation()) {
                isValid = false;
            }
            if (!claimPoints.func.checksurgeryNameField()) {
                return false;
            }
            return isValid;
        },
        submitQuery: function () {
            $(claimPoints.elements.notification).hide();
            if (claimPoints.func.isValid()) {
                $.ajax({
                    type: 'GET',
                    url: '/api/sitecore/ClaimPoints/ClaimVitalityPoints',
                    data: {
                        ActiveEntityId: $(claimPoints.elements.selectedValue).val(),
                        EventDate: $(claimPoints.elements.dateOfVisit).val()
                    },
                    success: claimPoints.func.onSuccess,
                    error: claimPoints.func.onError
                });
            }
        },
        onSuccess: function (data) {
            if (data.isSuccess) {
                $(claimPoints.elements.thanksModal).show();
            } else if (data.code !== undefined) {
                $(".vds-notification[data-notification-code='" + data.code + "']").show();
            } else {
                window.location.replace(claimPoints.urls.error);
            }
        },
        onError: function () {
            window.location.replace(claimPoints.urls.error);
        }
    }
};
